'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createInputNumberDirective = createInputNumberDirective;
function createInputNumberDirective(directivesModule) {
    function needsPolyfill() {

        ////// Betere check zou zijn: 
        ////// https://github.com/jonstipe/number-polyfill/blob/master/number-polyfill.js

        ////// i = document.createElement("input");
        ////// i.setAttribute("type", "number");
        ////// if (i.type === "text")  ===> needs polyfill

        ////// iets gelijkaardigs om te checken of min, max, steps ondersteund wordt value: bijv. value gelijk zetten aan value kleiner dan min, groter dan max
        ////// iets gelijkaardigs om numerieke content te checken; bijv. value gelijk zetten aan "a", als value daarna niet "a" is is 't OK

        // checks whether we're using an Internet Explorer 10+ or Edge
        //return (
        //    !!document.documentMode && !!window.atob // IE10+ without Edge
        //) ||
        //    (!!navigator.msLaunchUri // WIN8+
        //        && !!window.atob // IE10+, Edge
        //    );

        return true;
    }

    function hasRequiredAttributes(elem, attrs) {
        var isNumberField = elem.attr('type') && elem.attr('type').toLowerCase() === 'number';
        if (!isNumberField) {
            return false;
        }

        return !isNaN(parseFloat(attrs.max)) && !isNaN(parseFloat(attrs.min)) && !isNaN(parseFloat(attrs.step));
    }

    function createButton(value, modifierHandler) {
        var button = document.createElement('input');
        button.setAttribute('type', 'button');
        button.setAttribute('value', value);
        button.setAttribute('tabindex', '-1');
        var element = angular.element(button);
        element.on('click', modifierHandler);
        return button;
    }

    function createContainerDiv() {
        var div = document.createElement('div');
        div.setAttribute('class', 'input-number-container');
        return div;
    }

    function createSpan() {
        return document.createElement('span');
    }

    function isChildOfOrSame(parent, child) {
        var testElem = child;
        var steps = 3;

        for (; steps > 0; --steps) {
            if (!testElem) {
                return false;
            }
            if (parent === testElem) {
                return true;
            }
            testElem = testElem.parentElement;
        }

        return false;
    }

    if (needsPolyfill()) {
        directivesModule.directive('input', function () {
            return {
                restrict: 'E',
                scope: {},
                require: '?ngModel',
                link: function link(scope, elem, attrs, ngModel) {
                    var containerDiv = null;
                    var inputElem = elem[0];
                    var hiddenRangeInput;
                    var hiddenRangeInputJquery;
                    var hasMouse;

                    function hasFocus() {
                        return document.activeElement === inputElem;
                    }

                    // function notifyAmountExcedeed(){
                    //     var newEvent = document.createEvent('HTMLEvents');
                    //     newEvent.initEvent('amountExcedeed', true, false);
                    //     inputElem.dispatchEvent(newEvent);
                    // }

                    // stepUp, stepDown in IE work only for the range input type
                    function doStep(direction) {

                        if (elem.attr('readonly') === 'readonly') {
                            return;
                        }

                        var value = elem.val();
                        var min = attrs.min;
                        var max = attrs.max;

                        if (value !== 0 && !value) {
                            if (direction === 'up') {
                                value = min;
                            } else {
                                value = max;
                            }
                        }

                        hiddenRangeInput.setAttribute('min', min);
                        hiddenRangeInput.setAttribute('max', max);
                        hiddenRangeInput.setAttribute('value', value);
                        hiddenRangeInput.setAttribute('step', attrs.step);

                        //elem.after(hiddenRangeInput);
                        if (direction === 'up') {
                            hiddenRangeInput.stepUp();
                        } else {
                            hiddenRangeInput.stepDown();
                        }
                        hiddenRangeInputJquery = angular.element(hiddenRangeInput);
                        elem.val(hiddenRangeInputJquery.val());

                        ngModel.$setViewValue(elem.val() !== undefined ? parseInt(elem.val(), 10) : undefined);

                        var event = document.createEvent('HTMLEvents');
                        event.initEvent('change', true, false);
                        inputElem.dispatchEvent(event);
                    }

                    function createButtonClickHandler(direction) {
                        return function (event) {
                            doStep(direction);
                            inputElem.focus();
                            event.preventDefault();

                            return false;
                        };
                    }

                    function createContainerWithButtons() {
                        if (!hasRequiredAttributes(elem, attrs)) {
                            return;
                        }
                        containerDiv = createContainerDiv();
                        var span = createSpan();
                        var btnUp = createButton('▴', createButtonClickHandler('up'));
                        var btnDown = createButton('▾', createButtonClickHandler('down'));
                        hiddenRangeInput = document.createElement('input');
                        hiddenRangeInput.setAttribute('type', 'range');
                        hiddenRangeInput.setAttribute('style', 'display:none;');

                        span.appendChild(btnUp);
                        span.appendChild(btnDown);
                        containerDiv.appendChild(span);
                        containerDiv.appendChild(hiddenRangeInput);
                        elem.after(containerDiv);

                        angular.element(containerDiv).on('mouseleave', function (event) {
                            if (!event.relatedTarget || event.relatedTarget.parentElement !== inputElem) {
                                deleteContainerWithButtons(elem);
                            }
                        });
                    }

                    function deleteContainerWithButtons() {
                        var inputHasFocus = angular.element(elem).is(':focus');
                        if (inputHasFocus) {
                            return;
                        }

                        if (!containerDiv) {
                            return;
                        }

                        hiddenRangeInput = null;
                        angular.element(containerDiv).remove();
                        containerDiv = null;
                        hasMouse = false;
                    }

                    function registerInputElemEventHandler() {
                        elem.on('keydown', function (event) {
                            if (event.keyCode === 38) {
                                doStep('up');
                                event.preventDefault();
                            } else if (event.keyCode === 40) {
                                doStep('down');
                                event.preventDefault();
                            }
                        });

                        elem.on('keyup', function (event) {
                            if (event.keyCode === 16 // shift
                            || event.keyCode === 35 // home 
                            || event.keyCode === 36 // end
                            || event.keyCode === 37 // left arrow
                            || event.keyCode === 39) {
                                //right arrow
                                return;
                            }

                            if (event.keyCode !== 38 && event.keyCode !== 40) {
                                var value = elem.val();
                                hiddenRangeInput.setAttribute('min', attrs.min);
                                hiddenRangeInput.setAttribute('max', attrs.max);
                                hiddenRangeInput.setAttribute('step', attrs.step);

                                if (!value) {
                                    hiddenRangeInput.value = 0;
                                } else if (attrs.min && parseInt(value, 10) < parseInt(attrs.min, 10)) {
                                    hiddenRangeInput.value = parseInt(attrs.min, 10);
                                } else if (attrs.max && parseInt(value, 10) > parseInt(attrs.max, 10)) {
                                    hiddenRangeInput.value = parseInt(attrs.max, 10);
                                } else {
                                    hiddenRangeInput.value = value;
                                }

                                //elem.after(hiddenRangeInput);
                                hiddenRangeInputJquery = angular.element(hiddenRangeInput);
                                // var hiddenVal = hiddenRangeInputJquery.val();
                                elem.val(hiddenRangeInput.value);
                                ngModel.$setViewValue(elem.val() !== undefined ? parseInt(elem.val(), 10) : undefined);

                                var newEvent = document.createEvent('HTMLEvents');
                                newEvent.initEvent('change', true, false);
                                inputElem.dispatchEvent(newEvent);
                            }
                        });

                        elem.on('mouseenter', function () {
                            hasMouse = true;
                            if (containerDiv === null) {
                                createContainerWithButtons();
                            }
                        });

                        elem.on('mouseleave', function (event) {
                            if (event.relatedTarget && isChildOfOrSame(containerDiv, event.relatedTarget)) {
                                return;
                            }
                            if (hasFocus()) {
                                hasMouse = false;
                                return;
                            }
                            deleteContainerWithButtons();
                        });

                        elem.on('focus', function () {
                            if (containerDiv === null) {
                                createContainerWithButtons();
                            }
                        });

                        elem.on('focusout', function () {
                            if (hasMouse) {
                                return;
                            }
                            deleteContainerWithButtons();
                        });
                    }

                    if (hasRequiredAttributes(elem, attrs)) {
                        registerInputElemEventHandler();
                    }
                }
            };
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-input-number.js
// module id = 717
// module chunks = 0